import React from "react";
import { Button } from "react-bootstrap";

import CustomModal from "../CustomModal";

const ConfirmModal = ({
  show,
  title = "Confirm",
  message = "Are you sure want to delete it?",
  confirmLabel = "Yes",
  cancelLabel = "No",
  busy = false,
  onClose,
  onConfirm,
}) => {
  if (!show) return null;

  return (
    <CustomModal
      show={show}
      title={title}
      onClose={onClose}
      className="confirm-modal"
    >
      <p className="mb-4">{message}</p>

      <div className="d-flex gap-2">
        <Button
          variant=""
          className="btn-pill-outline flex-fill"
          onClick={onClose}
          disabled={busy}
        >
          <span>{cancelLabel}</span>
        </Button>
        <Button
          variant=""
          className="btn-pill-primary flex-fill"
          onClick={onConfirm}
          disabled={busy}
        >
          <span>
            {busy && <i className="fas fa-spin fa-spinner me-2" />}
            {confirmLabel}
          </span>
        </Button>
      </div>
    </CustomModal>
  );
};

export default ConfirmModal;
